import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { authProviders } from './shared/auth/auth.providers';
import { paymentProviders } from './shared/payment/payment.providers';
import { provideSupabaseConfig } from '@tokenbox/database';
import { environment } from '../environments/environment.development';
import { AppAuthService } from './shared/auth/services/app-auth.service';
import {
  NativeLocalStorageService,
  provideAuthService,
  provideLocalStorageService,
} from '@tokenbox/services';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';
import { providePrimeNG } from 'primeng/config';
import { CustomTheme } from './styles/theme';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    ...(!environment.showMaintenancePage ? authProviders : []),
    ...(!environment.showMaintenancePage ? paymentProviders : []),
    DialogService,
    ConfirmationService,
    MessageService,
    provideRouter(routes), // must be imported AFTER all other providers that define root routes (e.g. authProviders)
    provideAnimationsAsync(),
    providePrimeNG({
      theme: { preset: CustomTheme, options: { darkModeSelector: '.p-dark' } },
    }),
    provideSupabaseConfig(environment.supabase),
    provideAuthService(AppAuthService),
    provideMonacoEditor(),
    provideLocalStorageService(NativeLocalStorageService),
  ],
};
